import React from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import Form from "../../components/Form/Form";
import {
  CollectionListContainer,
  Heading,
  SubHeading,
  ListCard,
  BannerContainer,
  TextContainer,
  Container,
  Collections,
  CollectionDetail,
  ImageContainer,
  SyledCollectionLink,
  StyledHeading,
  CollectionHeading,
} from "./styles";

const Home = ({
  nftId,
  setNftID,
  NftData,
  setNftData,
  hideNFTview,
  setHideNFTview,
  loading,
  setLoading,
}) => {
  return (
    <>
      <Container>
        <BannerContainer>
          <TextContainer>
            <SubHeading>Check your favorite NFT collection rarity</SubHeading>
            <Heading>How Rare Is your NFT?</Heading>
            <h5>
              We list every new NFT rarity collection with fair ranking, better
              trait scoring and many features for collection owners and NFT
              hunters{" "}
            </h5>
          </TextContainer>
        </BannerContainer>
      </Container>
      <Form
        nftId={nftId}
        setNftID={setNftID}
        NftData={NftData}
        setNftData={setNftData}
        hideNFTview={hideNFTview}
        setHideNFTview={setHideNFTview}
        loading={loading}
        setLoading={setLoading}
      />

      <CollectionListContainer>
        <StyledHeading style={{ color: "#393939" }}>
          Recently Listed
        </StyledHeading>
        <Collections>
          <ListCard>
            <ImageContainer>
              <img loading="lazy" src="/gbetbackground.jpeg" alt="gbet" />
            </ImageContainer>

            <CollectionDetail>
              <CollectionHeading>GangstaBet Collection</CollectionHeading>
              <SyledCollectionLink
                style={{ textDecoration: "none" }}
                to="/collection/gangstabet"
              >
                View Collection
              </SyledCollectionLink>
            </CollectionDetail>
          </ListCard>
          <ListCard>
            <ImageContainer>
              <img loading="lazy" src="/krazycats.jpg" alt="gbet" />
            </ImageContainer>

            <CollectionDetail>
              <CollectionHeading>Krazy Cats Collection</CollectionHeading>
              <SyledCollectionLink style={{ textDecoration: "none" }} to="/">
                Coming Soon
              </SyledCollectionLink>
            </CollectionDetail>
          </ListCard>
          <ListCard>
            <ImageContainer>
              <img loading="lazy" src="/placeholder.png" alt="gbet" />
            </ImageContainer>

            <CollectionDetail>
              <CollectionHeading>Coming Soon</CollectionHeading>
              <SyledCollectionLink style={{ textDecoration: "none" }} to="/">
                Coming Soon
              </SyledCollectionLink>
            </CollectionDetail>
          </ListCard>
        </Collections>
      </CollectionListContainer>
    </>
  );
};

export default Home;
